module.exports = __webpack_public_path__ + "static/media/title-bg-how-to-work.8c0d1f6c.png";